
// Vue
import { Prop } from 'vue-property-decorator';
import { Component, Mixins } from 'vue-mixin-decorator';
// Components
import BasePage from '@/pages/BasePage.vue';
// Consts
import { TosType } from '@/common/consts';

/**
 * [SFR0026] 商品詳細 - 利用規約タブコンポーネント
 */
@Component
export default class ProductDetailFAQ extends Mixins<BasePage>(BasePage) {
  /** 利用規約区分 */
  @Prop({ default: '' })
  type!: string;

  /** 利用規約 HTMLコンテンツ */
  @Prop({ default: '' })
  tosText!: string;

  /** 利用規約 PDFコンテンツ */
  @Prop({ default: '' })
  tosPdf!: string;

  private isText(): boolean {
    return this.type === TosType.TEXT;
  }
}
